import React from 'react';
import Styles from './ValueSection.styled';
import ValuesIcon from '../../icons/values.svg';
import InView from '../Shared/InView';
import SimpleAnimation from '../../styles/Components/SimpleAnimation';

const ValueSection = ({ isAnimated = true, ...props }) => {
  return (
    <Styles>
      <InView>
        <div className='img-container'>
          <img src={ValuesIcon} />
        </div>
        <SimpleAnimation.div slideDirection='up' delay={0.6}>
          <div className='caption-container inner'>
            <div className='caption-item'>
              <h2>Open doors.</h2>
              <svg
                width='184'
                height='8'
                viewBox='0 0 184 8'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <rect width='184' height='8' fill='#97D700'></rect>
              </svg>
              <p>
                We are here to help our customers realize success, own homes
                they love, and create more opportunity for them down the road.
              </p>
            </div>
            <div className='caption-item'>
              <h2>Be a home.</h2>
              <svg
                width='184'
                height='8'
                viewBox='0 0 184 8'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <rect width='184' height='8' fill='#00B0AC'></rect>
              </svg>
              <p>
                We strive to be more than a place to work - where people have a
                sense of belonging, work-life balance, and a true career path.
              </p>
            </div>
            <div className='caption-item'>
              <h2>Drive change.</h2>
              <svg
                width='184'
                height='8'
                viewBox='0 0 184 8'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <rect width='184' height='8' fill='#00A0DD'></rect>
              </svg>
              <p>
                We must set the standard. Advance technology and sustainability,
                and implement visionary practices in all we do.
              </p>
            </div>
            <div className='caption-item'>
              <h2>Do good.</h2>
              <svg
                width='184'
                height='8'
                viewBox='0 0 184 8'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <rect width='184' height='8' fill='#8D83BE'></rect>
              </svg>
              <p>
                Be kind and collaborative. Promote equity, and be welcoming to
                everyone.
              </p>
            </div>
            <div className='caption-item'>
              <h2>Earn trust.</h2>
              <svg
                width='184'
                height='8'
                viewBox='0 0 184 8'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <rect width='184' height='8' fill='#FFC50A'></rect>
              </svg>
              <p>Nothing works without it.</p>
            </div>
          </div>
        </SimpleAnimation.div>
      </InView>
    </Styles>
  );
};

export default ValueSection;
